<template>
  <div>
    <div :id="mapid" class="mapa"></div>
    <div :class="'cortina' + (cidade != null ? ' show' : '')">
      <div v-if="cidade">
        <div class="card">
          <div class="card-header card-header-text">
            <div class="card-text">
              <h4 class="card-title">{{ titulo }}</h4>
            </div>
            <a @click="cidade = null"
               style="position: absolute;
                      right: 5px;
                      top: 10px;
                      cursor: pointer;
                      color: #000;
                      display: flex;
                      min-width: 20px;
                      min-height: 20px">
              <svg xmlns="http://www.w3.org/2000/svg"
                   @click="cidade = null"
                   width="20"
                   height="20"
                   fill="currentColor"
                   class="bi bi-x-lg"
                   viewBox="0 0 16 16">
                <path d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
              </svg>
            </a>
          </div>
          <div class="card-body"
               style="
               overflow: auto;
               max-height: calc(100vh - 200px);
               display: block;
               z-index: 10000;">
            <table class="table">
              <tbody>
                <tr>
                  <td>Nível de competitividade</td>
                  <td>{{ (cidade.nivel_competitividade * 100).toFixed(2).replace(".", ",") }}%</td>
                </tr>
                <tr>
                  <td>Quantidade de UC com GD</td>
                  <td>{{ numberWithCommas(cidade.quantidade_geracao_distribuida) }}</td>
                </tr>
                <tr>
                  <td>Potência instalada</td>
                  <td>{{ numberWithCommas(cidade.potencia_instalada) }}</td>
                </tr>
                <tr>
                  <td>Nível de geração</td>
                  <td>{{ cidade.nivel_geracao }}</td>
                </tr>
                <tr>
                  <td>População</td>
                  <td>{{ numberWithCommas(cidade.populacao) }}</td>
                </tr>
              </tbody>
            </table>
            <div style="width: 100%" ref="grafico" v-if="cidade && cidade.fontes"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .leaflet-div-icon {
    background: transparent;
    border-color: transparent;
  }
</style>

<script>
export default {
  data() {
    return {
      mapid: "mapid",
      titulo: "",
      pontos: [],
      mapa: null,
      marcas: [],
      cidade: null,
      selecionado: null,
    };
  },
  methods: {
    drawChart() {
      var d = [["Potência", "kW"]];
      for (const key in this.cidade.fontes) {
        d.push([key, this.cidade.fontes[key].dados.length]);
      }
      var data = google.visualization.arrayToDataTable(d);

      var options = {
        title: "Potência",
        pieHole: 0.4,
        legend: { position: "bottom" },
      };

      var chart = new google.visualization.PieChart(this.$refs.grafico);
      chart.draw(data, options);
    },
    grafico() {
      if (!this.cidade.fontes) {
        return;
      }
      google.charts.load("current", { packages: ["corechart"] });
      google.charts.setOnLoadCallback(this.drawChart);
    },
    buscarPontos() {
      callAPI(
        '/cidade/all',
        'GET',
        null,
        (e) => {
          this.pontos = e;
          this.colocarPontos();
        }
      );
    },
    buscarDetalhes() {
      callAPI(
        "/cidade/detalhes/" + this.cidade.cidade_id,
        'GET',
        null,
        (cidade) => {
          if ( cidade.geracao_distribuida.potencia_instalada <= 75000 ) {
            this.cidade.nivel_geracao = 'Microgeração';
          } else {
            this.cidade.nivel_geracao = 'Minigeração';
          }
          
          this.cidade.quantidade_geracao_distribuida = cidade.geracao_distribuida.quantidade_geracao_distribuida;
          this.cidade.potencia_instalada = cidade.geracao_distribuida.potencia_instalada;
          this.cidade.nivel_competitividade = cidade.geracao_distribuida.competitividade;

          this.grafico();
          this.$forceUpdate();
        }
      );
    },
    colocarPontos() {
      var max = 0;
      for (const key in this.marcas) {
        this.mapa.removeLayer(this.marcas[key]);
      }
      if (this.cidade) {
        var icone = L.divIcon({
          iconSize: [10, 10],
          html: `<div class="pin selecionado" title="${this.cidade.nome}"></div><div class="pulse"></div>`,
        });
        var marca = L.marker([this.cidade.latitude, this.cidade.longitude], {
          ponto: this.cidade,
          icon: icone,
        });
        marca.addTo(this.mapa);
        marca.on("click", this.cortina);
        this.marcas.push(marca);
      }
      for (const key in this.pontos) {
        var ponto = this.pontos[key];
        if (
          ponto.latitude <= this.mapa.getBounds()._northEast.lat &&
          ponto.latitude >= this.mapa.getBounds()._southWest.lat &&
          ponto.longitude <= this.mapa.getBounds()._northEast.lng &&
          ponto.longitude >= this.mapa.getBounds()._southWest.lng
        ) {
          var html = `<div class="pin" title="${ponto.nome}"></div>`;

          if (!this.cidade || this.cidade.id != ponto.id) {
            //  html = `<div class="pin selecionado" title="${ponto.nome}"></div><div class="pulse"></div>`;

            var icone = L.divIcon({
              iconSize: [10, 10],
              html: html,
            });
            var marca = L.marker(
              [this.pontos[key].latitude, this.pontos[key].longitude],
              {
                ponto: this.pontos[key],
                icon: icone,
              }
            );
            marca.addTo(this.mapa);
            marca.on("click", this.cortina);
            this.marcas.push(marca);

            if (++max == 25) {
              break;
            }
          }
        }
      }
    },
    cortina(e) {
      e.target._icon.firstChild;
      e.target._icon.firstChild.classList.add("ativo");
      var html = e.target._icon.innerHTML;
      html += '<div class="pulse"></div>';
      e.target._icon.innerHTML = html;
      this.mapa.panTo(e.latlng);
      var cidade = e.target.options.ponto;
      this.titulo = cidade.nome;
      this.cidade = cidade;
      this.buscarDetalhes();
    },
    iniMap() {
      var mapboxUrl = "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}";
      var mapboxAttribution = 'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>';
      var accessToken = "pk.eyJ1IjoiaWRlYXRvcyIsImEiOiJjazAzeGN0ZXYzOXR3M25tanh5eWx3Nnp4In0.wI21mFiszpDoRNUe5OzMpg";

      var layers = {
        streets: L.tileLayer(mapboxUrl, {
          id: 'mapbox/streets-v11',
          maxZoom: 18,
          tileSize: 512,
          zoomOffset: -1,
          accessToken: accessToken,
          attribution: mapboxAttribution
        }),
        outdoors: L.tileLayer(mapboxUrl, {
          id: 'mapbox/outdoors-v11',
          maxZoom: 18,
          tileSize: 512,
          zoomOffset: -1,
          accessToken: accessToken,
          attribution: mapboxAttribution
        }),
        light: L.tileLayer(mapboxUrl, {
          id: 'mapbox/light-v10',
          maxZoom: 18,
          tileSize: 512,
          zoomOffset: -1,
          accessToken: accessToken,
          attribution: mapboxAttribution
        }),
        dark: L.tileLayer(mapboxUrl, {
          id: 'mapbox/dark-v10',
          maxZoom: 18,
          tileSize: 512,
          zoomOffset: -1,
          accessToken: accessToken,
          attribution: mapboxAttribution
        }),
        satellite: L.tileLayer(mapboxUrl, {
          id: 'mapbox/satellite-v9',
          maxZoom: 18,
          tileSize: 512,
          zoomOffset: -1,
          accessToken: accessToken,
          attribution: mapboxAttribution
        }),
        satellite_street: L.tileLayer(mapboxUrl, {
          id: 'mapbox/satellite-streets-v11',
          maxZoom: 18,
          tileSize: 512,
          zoomOffset: -1,
          accessToken: accessToken,
          attribution: mapboxAttribution
        }),
      };

      var latLngBegin = [-29.68417, -53.80694];

      this.mapa = L.map(this.mapid, {
        center: latLngBegin,
        zoom: 12,
        layers: [layers.streets],
        zoomControl: true,
        layersControl: false
      });

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          var lat = position.coords.latitude;
          var lng = position.coords.longitude;
          this.mapa.setView([lat, lng], 10);
        }, null);
      }

      this.mapa.on("move", () => {
        this.colocarPontos();
      });

      var baseMaps = {
          "Ruas": layers.streets,
          "Elevação": layers.outdoors,
          "Light": layers.light,
          "Dark": layers.dark,
          "Satélite": layers.satellite,
      };

      L.control.layers(baseMaps).addTo(this.mapa);

      setTimeout(() => {
        this.mapa.invalidateSize();
      }, 100);
    },
    numberWithCommas(x) {
      var parts = x.toString().replace(".", ",");

      parts = parts.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      return parts;
    }
  },
  mounted() {
    this.iniMap();
  },
  created() {
    this.buscarPontos();
  },
  watch: {
    data() {
      this.colocarPontos();
    },
    id(id) {
      if (id != null) {
        this.buscarDetalhes(id);
      }
    },
    cidade(cidade) {
      if (cidade == null) {
        this.colocarPontos();
      }
    },
  },
};
</script>
